const PORTRAIT_URL = "/coach.jpg";

const PILASTRI = [
  { n: "01", color: "#a020f0", title: "Allenamento", text: "Schede personalizzate con video guida ed esecuzione carichi." },
  { n: "02", color: "#38bdf8", title: "Alimentazione", text: "Strategie nutrizionali su misura per definizione o massa." },
  { n: "03", color: "#c084fc", title: "Integrazione", text: "Consigli mirati basati su evidenze scientifiche." },
  { n: "04", color: "#38bdf8", title: "Supporto Chat", text: "Monitoraggio continuo dei progressi e feedback costante." },
];

export const ChiSono = () => (
  <section id="chi-sono" data-testid="chi-sono-section" className="py-24 px-6 bg-[#0a0513] border-t border-[#1e1038]">
    <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
      <div className="lg:col-span-5 relative group">
        <div className="relative w-full aspect-[4/5] rounded-2xl overflow-hidden border border-[#a020f0]/40 shadow-2xl shadow-[#6a0dad]/30">
          <img src={PORTRAIT_URL} alt="Coach MP Coaching" data-testid="coach-portrait"
            className="absolute inset-0 w-full h-full object-cover d1-drift" loading="lazy" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0a0513] via-transparent to-transparent"></div>
          <div className="absolute bottom-6 left-6 right-6">
            <span className="text-xs uppercase tracking-widest text-[#a020f0] font-bold mono-font">Coach Certificato</span>
            <p className="text-xl font-bold text-white">Laurea in Scienze Motorie</p>
          </div>
        </div>
      </div>

      <div className="lg:col-span-7 space-y-6">
        <div className="inline-block px-3 py-1 rounded bg-[#1e1038] text-[#a020f0] text-xs font-bold uppercase tracking-wider">
          Chi Sono
        </div>
        <h2 className="display-font text-3xl md:text-5xl uppercase text-white leading-tight">
          Ricomposizione corporea con metodo scientifico
        </h2>
        <p className="text-base text-[#cbd5e1] leading-relaxed">
          Laureato in Scienze Motorie, specializzato in ricomposizione corporea e bodybuilding.
          Mi piacciono le sfide e mi piace rendere felici le persone aiutandole a raggiungere
          i propri obiettivi: niente scorciatoie, solo un metodo costruito su di te.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-4">
          {PILASTRI.map((p) => (
            <div key={p.n} data-testid={`pilastro-${p.n}`} className="p-4 rounded-xl bg-[#120a21] border border-[#281647]">
              <div className="font-bold text-lg mb-1" style={{ color: p.color }}>{p.n}. {p.title}</div>
              <p className="text-xs text-[#94a3b8]">{p.text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
